import { render, staticRenderFns } from "./SenhaEsqueceuReset.vue?vue&type=template&id=6d3f305a&scoped=true"
import script from "./SenhaEsqueceuReset.vue?vue&type=script&lang=js"
export * from "./SenhaEsqueceuReset.vue?vue&type=script&lang=js"
import style0 from "./SenhaEsqueceuReset.vue?vue&type=style&index=0&id=6d3f305a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3f305a",
  null
  
)

export default component.exports